import { render, staticRenderFns } from "./OnechatGroupConsent.vue?vue&type=template&id=1d1e3ff2&scoped=true&"
import script from "./OnechatGroupConsent.vue?vue&type=script&lang=js&"
export * from "./OnechatGroupConsent.vue?vue&type=script&lang=js&"
import style0 from "./OnechatGroupConsent.vue?vue&type=style&index=0&id=1d1e3ff2&prod&lang=css&"
import style1 from "./OnechatGroupConsent.vue?vue&type=style&index=1&id=1d1e3ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e3ff2",
  null
  
)

export default component.exports